/**
 * Form Studio builder walkthrough (IsfPageTour).
 * Targets data-tour attributes on ESourceFormStudio.jsx.
 *
 * @param {object} [context]
 * @param {boolean} [context.isNew]
 */
export function buildEsourceFormStudioTourSteps(context = {}) {
  const { isNew = true } = context;

  return [
    {
      id: "welcome",
      placement: "center",
      title: "Welcome to Form Studio",
      body: isNew
        ? "Design free-form electronic source forms on a Word-style canvas. Drag tools onto the page, use AQ Assist inside the builder, then Save form with a code and name. Publish later from Form Management."
        : "Edit this form on the canvas, use AQ Assist inside Form Studio when you need help, then Save form to update the draft. Publish from Form Management when ready.",
    },
    {
      id: "refresh",
      target: '[data-tour="esource-fs-refresh"]',
      placement: "bottom",
      title: "Refresh",
      body: isNew
        ? "Refresh reloads Form Studio. Unsaved canvas changes on a new form may be lost."
        : "Refresh reloads the saved draft from the server so you can discard unsaved canvas changes.",
    },
    {
      id: "guide-button",
      target: '[data-tour="esource-fs-guide"]',
      placement: "bottom",
      title: "Page guide",
      body: "Click Guide anytime to replay this short Form Studio walkthrough.",
    },
    {
      id: "save",
      target: '[data-tour="esource-fs-save"]',
      placement: "bottom",
      title: "Save form",
      body: "Save opens a dialog for form code and name, then stores the draft. Publish stays on Form Management.",
    },
    {
      id: "canvas",
      target: '[data-tour="esource-fs-canvas"]',
      placement: "top",
      title: "Form canvas",
      body: "The middle area is Form Studio: tools on the left, page in the centre, properties on the right. Export PDF and AQ Assist live in the builder ribbon.",
    },
  ];
}
